module.exports = __webpack_public_path__ + "img/cloudy.e4c1f2cf.svg";